const ExpandButton = ({ elemId, isExpanded }) => {
  if (!elemId) return "";

  const btnClass = `btn-expend btn-floating btn-small${
    isExpanded ? " active" : ""
  }`;
  const addClass = isExpanded ? " hide" : "";
  const removeClass = isExpanded ? "" : " hide";

  return (
    `<a class="${btnClass}" dept-id=${elemId}>` +
    `<i class="material-icons icon-add${addClass}">add</i>` +
    `<i class="material-icons icon-remove${removeClass}">remove</i>` +
    `</a>`
  );
};

export default ExpandButton;
